module.exports = __webpack_public_path__ + "static/media/sydney-cityscape.346538aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/sydney-cityscape.jpg
// module id = 152
// module chunks = 0